export default {
  text: {
    id: 'review_display_ratebloc_text_new',
    defaultMessage: 'Average of {reviewsAmount, html} from the past 6 months.',
  },
  reviewsAmount: {
    id: 'review_display_ratebloc_text_reviews_amount',
    defaultMessage: `{totalReviews, plural,
      one {# review}
      other {# reviews}
    }`,
  },
}
